export const QUIZ_SCORE_STORAGE_KEY = 'BUSSINES_DAY_QUIZ_SCORE';
export const QUIZ_CURRENT_INDEX_QUESTION_STORAGE_KEY =
  'QUIZ_CURRENT_INDEX_QUESTION_STORAGE_KEY';
export const QUIZ_VIEW_STORAGE_KEY = 'BUSSINES_DAY_QUIZ_VIEW';
export enum QuizState {
  IDLE,
  GAME,
  EMAIL,
  RESULT,
}
